import React from 'react';

import dynamic from 'next/dynamic';

import WorldLogo from '@components/ui/WorldLogo/WorldLogo';
import Price from '@components/ui/price/index';
import { Separator } from '@components/formStyles';
import DiscountLabel from '@components/ui/labels/discount/DiscountLabel';
import { getCurrencySymbol } from '@utils/utils';
import { TourType } from '@api/v3';

import {
  RightCol,
  DiscountWrapper,
  StyledButton,
  CampaignLabelWrapper,
  RightWrapper,
  PriceDetails,
  FlexEnd,
} from './styled';
import { getDiscountType } from '../../helpers/getDiscountType';
import { SummaryCardProps } from './props';

const ExpediaPrice = dynamic(() => import('@components/ui/price/ExpediaPrice'));
const OriginalPrice = dynamic(
  () => import('@components/ui/price/OriginalPrice')
);

const SummaryCardDesktopDescription = ({
  onNavigate,
  prices,
  roomInformation,
  tourType,
  installments,
  isEmpty,
  isExpedia = false,
  toggleLetUsCallYou,
}: SummaryCardProps) => {
  const showOriginalPrice = isExpedia || (!isExpedia && prices?.discountRate);
  const showTotalPrice = Boolean(
    prices?.price != prices?.discountedPrice && isExpedia
  );
  const priceControl = prices?.tryPrice === prices?.discountedPrice;

  return (
    <RightCol>
      <RightWrapper>
        {!isExpedia && tourType !== TourType.CRUISE ? (
          <CampaignLabelWrapper>
            <WorldLogo label={installments} />
          </CampaignLabelWrapper>
        ) : null}
        {/* <DesktopStyledFreeCancellationWrapper>
          <ChippinCard />
        </DesktopStyledFreeCancellationWrapper> */}
        <Separator size='41px' />

        {prices?.price ? (
          <FlexEnd>
            {prices.discountRate ? (
              <DiscountWrapper>
                <DiscountLabel
                  discount={prices.discountRate}
                  type={getDiscountType(prices?.discountType)}
                  currency={prices.discountCurrency}
                />
              </DiscountWrapper>
            ) : null}
            <Price
              total={showTotalPrice}
              originalPriceSize={16}
              originalPriceCurrency={getCurrencySymbol(prices.currency)}
              originalPrice={prices.price}
              discountedPrice={prices.discountedPrice}
              sellingPrice={prices.tryDiscountedPrice}
              price={prices.tryDiscountedPrice}
              isTour={true}
              tourType={tourType}
            >
              {showOriginalPrice && !priceControl ? (
                <OriginalPrice
                  size={showTotalPrice ? 12 : 16}
                  price={prices.price}
                  currency={getCurrencySymbol(prices.currency)}
                  noLine={
                    prices.discountRate === 0 &&
                    prices.discountedPrice === prices.price
                  }
                />
              ) : null}

              {isExpedia ? (
                <ExpediaPrice
                  total={showTotalPrice}
                  originalPriceSize={16}
                  orginalDiscountedPrice={prices.discountedPrice}
                  originalPriceCurrency={getCurrencySymbol(prices.currency)}
                  originalPrice={prices.price}
                  currency={getCurrencySymbol(prices.currency)}
                  price={prices.price}
                />
              ) : null}
            </Price>

            <PriceDetails isTiny>'den başlayan fiyatlarla</PriceDetails>
            <PriceDetails isBold>{roomInformation}</PriceDetails>
          </FlexEnd>
        ) : null}
        <Separator />

        {isEmpty ? (
          <StyledButton variant='Primary' onClick={toggleLetUsCallYou}>
            Biz Sizi Arayalım
          </StyledButton>
        ) : (
          <StyledButton variant='Primary' onClick={onNavigate}>
            Tarihleri Gör
          </StyledButton>
        )}
      </RightWrapper>
    </RightCol>
  );
};

export default SummaryCardDesktopDescription;
